import { LangConstant } from "const";

export const WEB_ADMIN_MODE = 1;

export const WEB_ADMIN_LOGIN_MODE = 2;

export const WEB_ADMIN_VERIFY_MODE = 2;

export const ACTIVE_PAGINATION = 1;

export const ACTIVE_ASC = 1;

export const USERS_LIMITED_NUMBER = 10;

export const GET_USER_LAST_TIME_VALUE = 1;

export const DEFAULT_OFFSET_NUMBER = 0;

export const DEFAULT_NAME = "unknown";

export const USER_STATUS = {
  inactive: 0,
  joined: 1,
  deleted: 2,
  pending: 3,
  refused: 4,
};

export const GLOBAL_TYPE = 0;

export const ACTIVE_STATUS = { inactive: 0, active: 1 };

export const BRANCH_ACTIVE_STATUS = { inactive: 0, active: 1 };

export const USER_ACTIVE_STATUS = { inactive: 0, active: 1 };

export const ERROR_TYPE = {
  phoneFormat: 0,
  maxUser: 1,
  duplicate: 2,
};

export const BRANCH_ERROR_TYPE = {
  sendMessage: 0,
  audioCall: 1,
  videoCall: 2,
  audioGroupCall: 3,
  videoGroupCall: 4,
  updateProfile: 5,
};

export const OTP_TYPE = {
  smsOtp: 0,
  smartOtp: 2,
};

export const DEFAULT_OTP_LENGTH = 6;

export const SYSTEM_TRACKING_TYPE = {
  errorsList: 0,
  userActivities: 1,
};

export const SMART_OTP_CONFIGS = {
  expireAfter: 60 * 1000, // milliseconds
  blockTime: 5 * 60 * 1000, // milliseconds
  maxRetry: 4,
  length: 6,
};

export const LOGIN_ROLE = {
  ROOT: 0,
  ADMIN: 1,
  SERVICE_ADMIN: 2,
};

export const LOGGER_ACTION_TYPES = {
  LOGIN: 0,
  UPDATE_BRANCH_INFORMATION: 1,
  ADD_NEW_USERS: 2,
  ACTIVE_USER: 3,
  BLOCK_USER: 4,
  UPDATE_USER_INFORMATION: 5,
  RESET_USER_PASSWORD: 6,
  CHANGE_PASSWORD: 7,
  UPDATE_BRANCH_CONFIGS: 8,
  IMPORT_NEW_USERS_FROM_EXCEL: 9,
  LOGOUT: 10,
  ADD_BRANCH: 11,
  DELETE_BRANCH: 12,
  ACTIVATE_BRANCH: 13,
  DEACTIVATE_BRANCH: 14,
  CREATE_UNIT: 15,
  EDIT_UNIT: 16,
  DELETE_UNIT: 17,
  CREATE_DEPARTMENT: 18,
  EDIT_DEPARTMENT: 19,
  DELETE_DEPARTMENT: 20,
  ADD_DEPARTMENT_USERS: 21,
  REMOVE_DEPARTMENT_USERS: 22,
  CREATE_UNIT_CHANNEL: 23,
  CREATE_DEPARTMENT_CHANNEL: 24,
  CREATE_POSITION: 25,
  EDIT_POSITION: 26,
  DELETE_POSITION: 27,
  EDIT_ROLE_ACCOUNT: 28,
  EDIT_CONFERENCE: 29,
};

export const UNIT_ERROR = {
  MISSING_PARAMETERS: 0,
  IN_WRONG_FORMAT: 1,
  DUPLICATED: 2,
  CONTAIN_DEPARTMENTS: 3,
};

export const DEPARTMENT_ERROR = {
  MISSING_PARAMETERS: 0,
  IN_WRONG_FORMAT: 1,
  DUPLICATED: 2,
  CHANNEL_MISSING_PARAMETERS: 3,
  CHANNEL_DUPLICATED: 4,
  CONTAIN_POSITIONS: 5,
};

export const USER_ERROR = {
  MISSING_PARAMETERS: 0,
  IN_WRONG_FORMAT: 1,
  DUPLICATED: 2,
};

export const POSITION_ERROR = {
  MISSING_PARAMETERS: 0,
  IN_WRONG_FORMAT: 1,
  DUPLICATED: 2,
};

export const CONFERENCE_ERROR = {
  MISSING_PARAMETERS: 0,
  IN_WRONG_FORMAT: 1,
  DUPLICATED: 2,
};

export const ROLE_ACCOUNT_ERROR = {
  MISSING_PARAMETERS: 0,
  IN_WRONG_FORMAT: 1,
  DUPLICATED: 2,
};

export const CHANNEL_MODE = {
  public: { label: LangConstant.L_PUBLIC_MODE, code: 0 },
  private: { label: LangConstant.L_PRIVATE_MODE, code: 1 },
};

export const GROUP_TYPE = {
  INBOX: 0,
  GROUP: 1,
  CHANNEL: 2,
};

export const BRANCH_REQUEST_STATUS = {
  ALL: {
    label: LangConstant.TXT_BRANCH_STATUS_ALL,
    status: -1,
  },
  PENDING: {
    label: LangConstant.TXT_BRANCH_STATUS_PENDING,
    status: 0,
  },
  ACCEPTED: {
    label: LangConstant.TXT_BRANCH_STATUS_ACCEPTED,
    status: 1,
  },
  REJECTED: {
    label: LangConstant.TXT_BRANCH_STATUS_REJECTED,
    status: 2,
  },
};

export const BOT_MESSAGE_STATUS = {
  PENDING: {
    label: LangConstant.TXT_BOT_STATUS_PENDING,
    status: 0,
  },
  SUCCESS: {
    label: LangConstant.TXT_BOT_STATUS_SUCCESS,
    status: 1,
  },
  CANCELED: {
    label: LangConstant.TXT_BOT_STATUS_CANCELED,
    status: 2,
  },
  DRAFT: {
    label: LangConstant.TXT_BOT_STATUS_DRAFT,
    status: 3,
  },
  FAILED: {
    label: LangConstant.TXT_BOT_STATUS_FAILED,
    status: 4,
  },
};

export const STATE = {
  INACTIVE: 0,
  ACTIVE: 1,
  DELETED: 2,
  PENDING: 3,
  REJECT: 4,
  NO_ACTIVE_DEVICES: 5,
};

// branch_status (branch_account_status) chỉ nhận 0/1
export const BRANCH_STATUS = {
  DISABLED: 0,
  ACTIVE: 1,
};

// Các lựa chọn của cột & bộ lọc "Trạng thái hoạt động"
export const ACTIVE_FUNCTION = {
  DISABLED: "disabled", // Vô hiệu hóa
  LOGGED_IN: "loggedIn", // Đã đăng nhập
  NOT_LOGGED_IN: "notLoggedIn", // Chưa đăng nhập (PENDING)
  SUSPENDED: "suspended", // Ngưng hoạt động (NO_ACTIVE_DEVICES)
};

// Ánh xạ lựa chọn bộ lọc → tham số API (đã xác nhận với backend).
// Lựa chọn mặc định "Tất cả" (value "") KHÔNG có trong map → không gửi param nào.
export const ACTIVE_FUNCTION_PARAMS = {
  [ACTIVE_FUNCTION.DISABLED]: { branch_status: BRANCH_STATUS.DISABLED }, // KHÔNG gửi state
  [ACTIVE_FUNCTION.LOGGED_IN]: { branch_status: BRANCH_STATUS.ACTIVE, state: STATE.ACTIVE },
  [ACTIVE_FUNCTION.NOT_LOGGED_IN]: { branch_status: BRANCH_STATUS.ACTIVE, state: STATE.PENDING },
  [ACTIVE_FUNCTION.SUSPENDED]: { branch_status: BRANCH_STATUS.ACTIVE, state: STATE.NO_ACTIVE_DEVICES },
};

/**
 * Xác định nhãn hiển thị của cột "Trạng thái hoạt động" cho một bản ghi người dùng.
 * Dùng field thật từ API: branch_status = branch_account_status (camelize → branchAccountStatus),
 * state = state. Trả về khóa ACTIVE_FUNCTION hoặc null (ô trống).
 *
 * Thứ tự ưu tiên:
 *  (1) branch_status = 0 → Vô hiệu hóa (ưu tiên tuyệt đối, bất kể state)
 *  (2) branch_status = 1 → theo state:
 *        ACTIVE(1)            → Đã đăng nhập
 *        PENDING(3)          → Chưa đăng nhập
 *        NO_ACTIVE_DEVICES(5) → Ngưng hoạt động
 *        INACTIVE(0)/REJECT(4)/DELETED(2)/khác → null (ô trống)
 */
export const resolveActiveFunction = user => {
  if (!user) return null;
  const branchStatus = user.branchAccountStatus;
  const state = user.state;

  if (branchStatus === BRANCH_STATUS.DISABLED) return ACTIVE_FUNCTION.DISABLED;

  if (branchStatus === BRANCH_STATUS.ACTIVE) {
    switch (state) {
      case STATE.ACTIVE:
        return ACTIVE_FUNCTION.LOGGED_IN;
      case STATE.PENDING:
        return ACTIVE_FUNCTION.NOT_LOGGED_IN;
      case STATE.NO_ACTIVE_DEVICES:
        return ACTIVE_FUNCTION.SUSPENDED;
      default:
        return null;
    }
  }
  return null;
};

export const BOT_ACCOUNT_PHONE = "bot@bglobal.com";

export const GROUP_TYPE_NAME = {
  0: LangConstant.TXT_GROUP_TYPE_INBOX,
  1: LangConstant.TXT_GROUP_TYPE_GROUP,
  2: LangConstant.TXT_GROUP_TYPE_CHANNEL,
};

export const SERVICE_ID = {
  conference: "3",
  calendar: "4",
};

export const TAB_USER_MANAGEMENT_VALUE = {
  userList: "userList",
  userRequest: "userRequest",
  userReject: "userReject",
};

export const MIN_CHANNEL_MEMBER_LENGTH = 3;
